module.exports = __webpack_public_path__ + "img/Manufacturing_1200x800.3c2a45cf.png";